import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    // Defer FB Pixel until browser is idle — keeps it off the critical path
    const load = () => {
      const w = window as any;
      if (w.fbq) return;
      const q: any[] = [];
      w.fbq = (...args: any[]) => q.push(args);
      w.fbq.queue = q;
      w.fbq.loaded = true;
      w.fbq.version = '2.0';
      w._fbq = w.fbq;
      const s = document.createElement('script');
      s.async = true;
      s.defer = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      if (first?.parentNode) {
        first.parentNode.insertBefore(s, first);
      } else {
        document.head.appendChild(s);
      }
      w.fbq('init', '963209226060498');
      w.fbq('track', 'PageView');
    };
    // Use requestIdleCallback when available, otherwise defer 2s after load
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(load, {
        timeout: 4000
      });
    } else {
      const t = setTimeout(load, 2000);
      return () => clearTimeout(t);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}